<template>
  <div>
    <a-transfer
      :data-source="mockData"
      :target-keys="targetKeys"
      :disabled="disabled"
      :show-search="showSearch"
      :filter-option="(inputValue, item) => item.title.indexOf(inputValue) !== -1"
      :show-select-all="false"
      @change="onChange"
    >
      <template
        slot="children"
        slot-scope="{
          props: { direction, filteredItems, selectedKeys, disabled: listDisabled },
          on: { itemSelectAll, itemSelect },
        }"
      >
        <a-table
          :row-selection="
            getRowSelection({ disabled: listDisabled, selectedKeys, itemSelectAll, itemSelect })
          "
          :columns="direction === 'left' ? leftColumns : rightColumns"
          :data-source="filteredItems"
          size="small"
          :style="{ pointerEvents: listDisabled ? 'none' : null }"
          :custom-row="
            ({ key, disabled: itemDisabled }) => ({
              on: {
                click: () => {
                  if (itemDisabled || listDisabled) return;
                  itemSelect(key, !selectedKeys.includes(key));
                },
              },
            })
          "
        />
      </template>
    </a-transfer>
  </div>
</template>
<script>
import difference from 'lodash/difference';
import {fetchSelect, userRange} from '@/utils/mixins';
const mockData = [];

const leftTableColumns = [
  {
    dataIndex: 'title',
    title: '可选小区'
  }
];
const rightTableColumns = [
  {
    dataIndex: 'title',
    title: '已选小区'
  }
];
export default {
  mixins: [fetchSelect, userRange],
  data () {
    return {
      mockData: [],
      targetKeys: [],
      disabled: false,
      showSearch: true,
      leftColumns: leftTableColumns,
      rightColumns: rightTableColumns
    };
  },
  created () {
    // this.init();
  },
  methods: {
    setTarget (val) {
      this.targetKeys = [].concat(val);
    },
    init (e) {
      this.$get({
        url: '/community/treeselect/page',
        params: {
          areas: e.join(','),
          pageNum: 1,
          pageSize: 999999
        }
      }).then(({data}) => {
        let arr = [];
        data.rows && data.rows.forEach((el) => {
          arr.push({
            title: el.label,
            key: `${el.value}`
          });
        });
        this.mockData = arr;
      });
    },
    onChange (nextTargetKeys) {
      this.targetKeys = nextTargetKeys;
    },
    getRowSelection ({ disabled, selectedKeys, itemSelectAll, itemSelect }) {
      return {
        getCheckboxProps: item => ({ props: { disabled: disabled || item.disabled } }),
        onSelectAll (selected, selectedRows) {
          const treeSelectedKeys = selectedRows
            .filter(item => !item.disabled)
            .map(({ key }) => key);
          const diffKeys = selected
            ? difference(treeSelectedKeys, selectedKeys)
            : difference(selectedKeys, treeSelectedKeys);
          itemSelectAll(diffKeys, selected);
        },
        onSelect ({ key }, selected) {
          itemSelect(key, selected);
        },
        selectedRowKeys: selectedKeys
      };
    }
  }
};
</script>
